module.exports = __webpack_public_path__ + "static/media/trainer.1c4a534a.svg";